/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import PropTypes from 'prop-types';
import { getContentByLocal } from '../../../utils';

const getDefaultAnswer = (item, lang) => {
    let defaultAnswer = '';
    item.answers && item.answers.forEach((answer) => {
        if (item.userAnswer && item.userAnswer.chosenAnswerId) {
            if (item.userAnswer.chosenAnswerId === answer.answerId) {
                defaultAnswer = getContentByLocal(answer.answerLocales, lang);
            }
        }
    })
    return defaultAnswer
}

const PreviewQuestionAccount = (props) => {
    const {
        title,
        accountI18n,
        dataId,
        modifyInfo,
        selectedLanguage,
        isApplicable,
        handleChangeToEdit
    } = props;

    return(
        <div className="preview-list" data-id={dataId}>
            <h3 className="preview-h3">{title}
                <button className="btn btn-link title-modify" title={modifyInfo} onClick={(event) => handleChangeToEdit(event, 'accountQuestion')}>
                    {modifyInfo}
                </button>
            </h3>
            <div className="preview-list-box">
                {
                    accountI18n.questions && accountI18n.questions.map((question, index) => {
                        const { 
                            questionLocales,
                            hintLocales,
                            hintStyle,
                            questionIndicator,
                            questionId
                        } = question;
                        const defaultAnswer = getDefaultAnswer(question, selectedLanguage);
                        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
                        const questionMarkDetail = (hintStyle=== "{\"style\":1}") && getContentByLocal(hintLocales, selectedLanguage);
                        if (isApplicable && (questionId === 'Q002-001' || questionId === 'Q002-002' || questionId === 'Q002-005')) {
                            return null;
                        } else {
                            return (
                                <div className="preview-open-box" key={index}>
                                    <div className="control-label">
                                        {/*<p className="number">{index+1}.</p>*/}
                                        <p className="title" data-key={`title-${questionIndicator}`}>
                                            <span>{questionTitle}</span>
                                            {questionMarkDetail && <span className="tip">{questionMarkDetail}</span>}
                                        </p>
                                    </div>
                                    <div className="previes-answer" data-key={`answer-${questionIndicator}`}>{defaultAnswer}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
        </div>
    );
};

PreviewQuestionAccount.propType = {
    dataId: PropTypes.string.isRequired,
    modifyInfo: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    accountI18n: PropTypes.object.isRequired

};
export default PreviewQuestionAccount;


// WEBPACK FOOTER //
// ./src/views/PreviewQuestion/components/PreviewQuestionAccount.js